import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Octopus = () => {
    return (
        <main>
            <div className="dev-section">
                <h1>☊ Octopus ☊</h1>

                <div className="dev-container">
                    <a className="external-item" href="https://testing.octopusrgs.com/#/versa" target="blank">
                        Octopus RGS Test Site
                    </a>
                    <Link className="external-item" to="/octoForces/">
                        Octopus Force Tools
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default Octopus;
